import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { TermTutor } from './term-tutor';
export { TermTutor };
import { termTutorSchema } from '@schemas/business-objects/term-tutor';
import { ActivityAssignmentFormArray } from './activity-assignment-form-group';
import { AttendanceFormArray } from './attendance-form-group';
import { NotAvailableFormArray } from './not-available-form-group';
import { StudentAssignmentFormArray } from './student-assignment-form-group';
import { TermFormGroup } from './term-form-group';
import { TutorFormGroup } from './tutor-form-group';

export class TermTutorFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    termId: SchemaFormControl;
    term: TermFormGroup;
    tutorId: SchemaFormControl;
    tutor: TutorFormGroup;
    activityAssignments: ActivityAssignmentFormArray;
    studentAssignments: StudentAssignmentFormArray;
    notAvailables: NotAvailableFormArray;
    attendances: AttendanceFormArray;
  };

  declare value: Partial<TermTutor>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(termTutorSchema, TermTutor, data, options);
  }

  get object(): TermTutor {
    return new TermTutor(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'term':
        return new TermFormGroup();
      case 'tutor':
        return new TutorFormGroup();
      case 'activityAssignments':
        return new ActivityAssignmentFormArray();
      case 'studentAssignments':
        return new StudentAssignmentFormArray();
      case 'notAvailables':
        return new NotAvailableFormArray();
      case 'attendances':
        return new AttendanceFormArray();
      default:
        return undefined;
    }
  }

  static async find(filter?: any): Promise<TermTutor[]> {
    return TermTutor.find(filter);
  }

  static async findOne(filter?: any): Promise<TermTutor | null> {
    return TermTutor.findOne(filter);
  }

  static async findById(id: number, filter?: any): Promise<TermTutor> {
    return TermTutor.findById(id, filter);
  }

  static async create(data: Partial<TermTutor>): Promise<TermTutor> {
    return TermTutor.create(data as any);
  }

  static async updateById(
    id: number,
    updates: Partial<TermTutor>,
  ): Promise<TermTutor> {
    return TermTutor.updateById(id, updates as any);
  }

  static async deleteById(id: number): Promise<boolean> {
    return TermTutor.deleteById(id);
  }
}

export class TermTutorFormArray extends PersistedFormArray {
  readonly entityName = 'TermTutor' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(termTutorSchema, TermTutor, options);
  }

  protected override createItemGroup() {
    return new TermTutorFormGroup();
  }

  get array(): TermTutor[] {
    return this.controls.map((group: TermTutorFormGroup) => group.object);
  }
}

export class TermTutorPersistedArray extends PersistedArray<TermTutor> {
  readonly entityName = 'TermTutor' as const;

  constructor(options?: PersistedArrayOptions) {
    super(TermTutor, options);
  }
}
